import { useEffect, useState } from 'react';
import { COUNTDOWN_SECONDS } from '../data/site';

// Shared start time keeps every timer on the page in sync.
const startedAt = Date.now();

function getRemaining(): number {
  const elapsed = Math.floor((Date.now() - startedAt) / 1000);
  return COUNTDOWN_SECONDS - (elapsed % COUNTDOWN_SECONDS);
}

export function useCountdown() {
  const [remaining, setRemaining] = useState(getRemaining);

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;
  const pad = (n: number) => String(n).padStart(2, '0');

  return { hours: pad(hours), minutes: pad(minutes), seconds: pad(seconds) };
}
